import { Modal as HopinModal } from '@hopin-team/ui-modal';
import styled from 'styled-components';

export const Modal = styled(HopinModal)`
  div[role='dialog'] {
    transition: width 0.3s ease;
  }
`;
